import { i18next } from '@frontend/i18n';

/**
 * Validates phone-related names (SIP profile names, caller names, etc.)
 * Blocks specific invalid characters: | : @ ^ < > " =
 * Enforces 26 character limit
 */
export const validateName = ({ value, fieldName = 'name' }: { value: string; fieldName?: string }) => {
  // Block ONLY these characters: | : @ ^ < > " =
  const invalidPattern = /[|:^@<>"=]/;

  if (invalidPattern.test(value)) {
    return i18next.t('Invalid characters: | : @ ^ < > " =', { ns: 'phone' });
  }

  if (value.length > 26) {
    return i18next.t('{{count}}/26 characters. Shorten {{fieldName}} to 26 characters.', {
      count: value.length,
      fieldName,
      ns: 'phone',
    });
  }

  return '';
};

/**
 * Validates audio file names for phone system
 * Only allows: letters, numbers, underscore, hyphen, and spaces
 * Enforces 26 character limit
 */
export const validateAudioFileName = ({ value }: { value: string }) => {
  // Allow ONLY: letters, numbers, underscore, hyphen, and spaces
  const validPattern = /^[A-Za-z0-9 _-]+$/;

  if (!validPattern.test(value)) {
    return i18next.t('Only letters, numbers, underscore (_), hyphen (-), and spaces are allowed.', { ns: 'phone' });
  }

  if (value.length > 26) {
    return i18next.t('{{count}}/26 characters. Shorten label to 26 characters.', {
      count: value.length,
      ns: 'phone',
    });
  }

  return '';
};
